import { cn } from '@baseball-near-you/ui';
import type { ReactNode } from 'react';

export function SanityWrapper({
  children,
  className,
  ref,
}: {
  children: ReactNode;
  className?: string;
  ref?: React.RefObject<HTMLDivElement | null>;
}) {
  return (
    <div
      className={cn(
        'flex h-full min-h-[20rem] w-full items-start justify-center lg:max-w-6xl',
        className
      )}
      ref={ref}
    >
      <div
        className="h-full w-full px-4"
        style={{
          minHeight: 'inherit',
        }}
      >
        {children}
      </div>
    </div>
  );
}

export function Pretitle(props: { pretitle: string }) {
  return (
    <h3 className="-mb-1! font-medium font-workSans text-md! text-red">
      {props.pretitle}
    </h3>
  );
}

export function Title(props: { title: string; className?: string }) {
  return (
    <h2
      className={cn(
        'title !text-center md:!text-left my-2 text-[1.6rem]',
        props.className
      )}
      style={{
        letterSpacing: 'normal',
        lineHeight: '1.75rem',
      }}
    >
      {props.title}
    </h2>
  );
}
